import { render } from "./CommunicationTargetRole.vue?vue&type=template&id=feb41d84&scoped=true&ts=true"
import script from "./CommunicationTargetRole.vue?vue&type=script&lang=ts"
export * from "./CommunicationTargetRole.vue?vue&type=script&lang=ts"

import "./CommunicationTargetRole.vue?vue&type=style&index=0&id=feb41d84&scoped=true&lang=css"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-feb41d84"]])

export default __exports__